<template>
  <div class="vipwrap">
    <div v-if="userinfo && !loading" class="vipPage">
      <div class="navheader">
        <div class="navtitle">
          <img class="headimgUrl" :src="userinfo.headimgUrl" alt="" />

          <div class="name">
            <div style="font-size: 18px;margin-bottom: 4px;">{{ userinfo.nickName }}</div>
            <div style="font-size: 12px;" v-if="ycUserinfos == null">未绑定一尘用户</div>
            <div style="font-size: 12px;" v-else>网名：{{ ycUserinfos.userName }}</div>
          </div>

          <div class="ycUserinfos">
            <div @click="backBindYC" v-if="ycUserinfos == null" class="bindycuser">
              绑定一尘账号
            </div>

            <template v-else>
              <div class="bindyc">
                <div @click="out" class="bindycuser">
                  更换一尘用户
                </div>
              </div>
            </template>
          </div>
        </div>
        <!-- <div class="backhome"><van-icon name="home-o"></van-icon></div> -->
        <div class="backhome">
          <!-- <van-button to="/plate" type="info" size="small">绑定一尘用户</van-button> -->
        </div>
      </div>
      <vipinfos :type="1" :userinfo="userinfo" :createPostInfos="createPostInfos"></vipinfos>
      <div class="section">
        <van-cell title="VIP会员" is-link to="/vip"><template #icon>
            <img style="width: 22px;height: 22px;margin-right: 8px;" :src="require('../../assets/img/vipusericon.png')"
              alt="" /> </template></van-cell>
        <van-cell title="关注贴" is-link to="/follow"><template #icon>
            <img style="width: 22px;height: 22px;margin-right: 8px;" :src="require('../../assets/img/scicon.png')"
              alt="" /> </template></van-cell>
        <van-cell title="我发布的帖子" is-link to="/createPost/list"><template #icon>
            <img style="width: 20px;height: 20px;margin-right: 8px;" :src="require('../../assets/img/pushtzicon.png')"
              alt="" /> </template></van-cell>
        <van-cell title="我参与的帖子" is-link to="/participates"><template #icon>
            <img style="width: 20px;height: 20px;margin-right: 8px;"
              :src="require('../../assets/img/participatesIcon.png')" alt="" /> </template></van-cell>

        <van-cell v-if="isAgent" title="分享邀请开通会员(8折折扣 代理专属)" is-link to="/activity"><template #icon>
            <img style="width: 22px;height: 22px;margin-right: 8px;" :src="require('../../assets/img/peicon.png')"
              alt="" /> </template></van-cell>
        <van-cell title="黑名单" is-link to="/blacklist"><template #icon>
            <img style="width: 22px;height: 22px;margin-right: 8px;" :src="require('../../assets/img/usericon.png')"
              alt="" /> </template></van-cell>
        <van-cell @click="clear" title="清除缓存">
          <template #icon>
            <img style="width: 22px;height: 22px;margin-right: 8px;" :src="require('../../assets/img/delicon.png')"
              alt="" />
          </template>
        </van-cell>
      </div>
    </div>
  </div>

  <!-- <div class="wrap">
    <van-skeleton title avatar :loading="loading" :row="3">
      <div v-if="!loading" class="demo-preview">
        <img class="tx" :src="userinfo.headimgUrl" alt="" />
        <div class="content">
          <h3 style="display: flex;align-items: center;">
            {{ userinfo.nickName }}
            <div class="ycUserinfos">
              <van-button
                v-if="ycUserinfos == null"
                @click="backBindYC"
                style="margin-left:5px"
                plain
                hairline
                size="mini"
                type="info"
                >绑定一尘账号</van-button
              >
              <template v-else>
                <div class="bindyc">
                  <div
                    style="font-size:12px;margin-left:5px;line-height: 14px;"
                    plain
                    hairline
                    size="mini"
                    type="warning"
                  >
                    已绑定一尘账号
                    <br />网名：{{ ycUserinfos.userName }}
                  </div>
                  <van-button @click="out" style="margin-left:5px" hairline size="mini" type="info"
                    >&nbsp;退&nbsp;出&nbsp;</van-button
                  >
                </div>
              </template>
            </div>
          </h3>

          <p>
            <img class="vipicon" v-if="isvip && isFtvip" src="../../assets//img/svip2.png" alt="" />
            <img class="vipicon" v-else-if="isvip" src="../../assets//img/svip3.png" alt="" />
            <img class="vipicon" v-else-if="isFtvip" src="../../assets//img/svip1.png" alt="" />
          </p>
        </div>
      </div>
    </van-skeleton>
    <template v-if="!loading">
      <van-cell @click="backpostList" title="我发表的贴子" is-link to="" />
      <van-cell title="我的盯盘" is-link to="/subscribe" />
      <van-cell title="我的关注贴" is-link to="/follow" />
      <van-cell
        :title="userinfo.vipExpireTime || isFtvip ? '我的会员' : '开通会员'"
        is-link
        :to="'/vip?t=' + new Date().getTime()"
      />
      <van-cell v-if="isAgent" title="分享邀请开通会员(8折折扣 代理专属)" is-link to="/activity" />
      <van-cell title="我的黑名单" is-link to="/blacklist" />
      <van-cell @click="clear" title="清除缓存" />
    </template>
  </div> -->
</template>
<script>
import { wxuser } from '@/api/base';
import { formatDateTimeRT, setFormateDateEnd } from '@/utils/index';
import vipinfos from '../components/vipinfos.vue';
export default {
  components: {
    vipinfos,
  },
  data() {
    return {
      userinfo: null,
      loading: true,
      ycUserinfos: null,
      isvip: false,
      isFtvip: false,
      isAgent: false,
      createPostInfos: null,
    };
  },
  created() {
    this.getUserinfo();
  },
  methods: {
    handleLink() {
      this.$router.push('/createPost/participates')
    },
    getUserinfo() {
      wxuser().then(res => {
        res.data.wxUser.isVip = 0;
        this.isAgent = res.data.isAgent || false;
        let now = new Date().getTime() / 1000;
        res.data.vipInfos.map(item => {
          if (item.vipType == 1) {
            if (now < new Date(item.validityTime).getTime() / 1000) {
              res.data.wxUser.isVip = 1;
              this.isvip = true;
            }
            res.data.wxUser.vipExpireTime = setFormateDateEnd(item.validityTime);
            console.log(res.data.wxUser.vipExpireTime);
          }
          // if (item.vipType == 2) {
          //   item.validityTime = formatDateTimeRT(item.validityTime);
          //   this.vipCompress = item;
          // }
          if (item.vipType == 3) {
            item.validityTime = setFormateDateEnd(item.validityTime);
            this.createPostInfos = item;
          }
        });
        this.userinfo = res.data.wxUser;
        this.loading = false;
        window.localStorage.setItem('userInfo', JSON.stringify(this.userinfo));
        this.$store.commit('setUserinfo', res.data.wxUser);

        this.ycUserinfos = JSON.parse(window.localStorage.getItem('ycUserinfos'));
      });
    },
    clear() {
      window.localStorage.clear();
      this.$toast('清除成功');
    },
    backBindYC() {
      this.$router.replace({
        path: '/yclogin',
        query: { r: encodeURIComponent(encodeURIComponent(window.location.href)) },
      });
    },
    out() {
      window.localStorage.clear();
      this.ycUserinfos = null;
    },
    backpostList() {
      if (this.ycUserinfos) {
        this.$router.push('/postList');
        return;
      }
      this.$dialog
        .alert({
          title: '提示',
          message: '请绑定一尘账号后方可查看~',
        })
        .then(() => {
          // on close
        });
    },
  },
};
</script>
<style lang="less" scoped>
.vipwrap {
  background: url('../../assets//img/vipHeaderbg.jpg') top no-repeat;
  width: 100%;
  background-size: 100% auto;

  .vipPage {
    padding: 20px 16px;

    .navheader {
      margin-bottom: 25px;
      display: flex;
      justify-content: space-between;
    }

    .navtitle {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      font-size: 14px;
      font-weight: 400;
      letter-spacing: 0px;
      line-height: 18px;
      color: #fff;
    }

    .headimgUrl {
      width: 48px;
      height: 48px;
      border-radius: 50%;
      margin-right: 10px;
      border: 1px solid #fff;
      box-shadow: 0px 1px 5px 1px rgba(0, 0, 0, 0.08);
    }

    .bindycuser {
      position: absolute;
      right: 0;
      border-radius: 14px 0px 0px 14px;
      background: linear-gradient(0deg, rgba(255, 8, 68, 1) 0%, rgba(255, 177, 153, 1) 100%);
      font-size: 14px;
      color: #fff;
      top: 23px;
      padding: 4px 0 4px 13px;
    }
  }

  .section .van-cell {
    align-items: center;

    .van-cell__left-icon {
      height: auto;
    }
  }
}
</style>
